import { z } from 'zod/v4';
import { copiedPanelSourceSchema, timeDashboardSchema } from './utils';
//import { chronosphereDataQueryDefinitionSchema, chronospherePanelDefinitionSchema } from './dashboard';
//import { createPanelDefinitionSchema } from './utils';

/**
 * Create an artifact schema definition
 */
export const createArtifactSchema = <Spec extends z.ZodTypeAny, Kind extends string>(kind: Kind, spec: Spec) => {
  return z.object({
    id: z.string().readonly(),
    kind: z.literal(kind),
    version: z.number(),
    spec,
  });
};

/*
  This is resulting in a "Type instantiation is excessively deep and possibly infinite." error. 

  For now, going to just make the panel schema, "anything" and we can deal with casting at usage point

const panelDefinitionSchema = createPanelDefinitionSchema(
  chronospherePanelDefinitionSchema,
  chronosphereDataQueryDefinitionSchema
);


const vizPanelArtifactSchema = createArtifactSchema('VizPanel', panelDefinitionSchema);
*/

const metadataSchema = z.object({ source: copiedPanelSourceSchema.optional() });

const vizPanelArtifactSchema = createArtifactSchema('VizPanel', z.any()).extend({
  metadata: metadataSchema.optional(),
});

export const entityArtifactSchema = createArtifactSchema(
  'Entity',
  z.object({
    entityType: z.string(),
    slug: z.string(),
    name: z.string(),
  })
);

export const alertHeatMapArtifactSchema = createArtifactSchema(
  'AlertHeatMap',
  z.object({
    monitorSlugs: z.array(z.string()).default([]),
    groupBy: z.enum(['monitor', 'notifier', 'notification_policy', 'label']).default('monitor'),
    sortOrder: z
      .enum(['alert_count_desc', 'alert_count_asc', 'alphabetical_asc', 'alphabetical_desc'])
      .default('alert_count_desc'),
    filterState: z.string().default('all'),
    showRelatedAlerts: z.boolean().default(true),
    showMutedAlerts: z.boolean().default(true),
    notificationPolicySlugs: z.array(z.string()).default([]),
    notifierSlugs: z.array(z.string()).default([]),
    minDurationMinutes: z.number().optional(),
    maxDurationMinutes: z.number().optional(),
    signalFilter: z
      .array(
        z.object({
          name: z.string(),
          value: z.string(),
        })
      )
      .default([]),
    visibleLabelKeys: z.array(z.string()).default(['all']),
  })
);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const artifactSchema = z.discriminatedUnion('kind', [
  vizPanelArtifactSchema,
  entityArtifactSchema,
  alertHeatMapArtifactSchema,
]);

export const notebookSchema = z.object({
  document: z.object({ type: z.string().optional(), content: z.array(z.any()).optional() }), // ProseMirror document
  context: z.object({}).optional(),
  name: z.string(),
  version: z.number(),
  time: timeDashboardSchema.optional(),
  id: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export interface NotebookSchema extends z.TypeOf<typeof notebookSchema> {}
export type ArtifactSchema = z.TypeOf<typeof artifactSchema>;
export interface VizPanelArtifactSchema extends z.TypeOf<typeof vizPanelArtifactSchema> {}
export interface EntityArtifactSchema extends z.TypeOf<typeof entityArtifactSchema> {}
export interface AlertHeatMapArtifactSchema extends z.TypeOf<typeof alertHeatMapArtifactSchema> {}
export interface MetadataSchema extends z.TypeOf<typeof metadataSchema> {}
